import { Redirect } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';

WebBrowser.maybeCompleteAuthSession();

const AuthCallbackRoute = () => <Redirect href="/" />;

export default AuthCallbackRoute;
